import { _APP_DATA } from "../data/AppData";
import { _SetGroupInUserInfo } from "../data/ManageUserInfo";
import { IConfiguration, IGroup } from "../data/models/Entities";
import { _SvAlumnoClearChildsData } from "../data/services/Alumno";
import { _SvEscolaridadObtenerConfiguracion } from "../data/services/Escolaridad";
import { _SvEscuelaClearKinderData } from "../data/services/Escuela";
import { _ClearEventsData } from "../data/services/Evento";
import { _GRUPOSINFO_MAP, _SvGrupoClearMaestrosInfoData } from "../data/services/Grupo";
import { _SvLogroClearData } from "../data/services/Logro";
import { _SvUsuarioObtenerGrupos } from "../data/services/Usuario";
import { _RestartAndCreateDB } from "../data/utils/General";
import { _GetHashInfo } from "../routes/Router";
import { _HashAssign } from "../routes/UIManager";
import { LOADING } from "../ui/components/Loading";
import { ShowToast } from "../ui/components/Toast";
import { _HttpMsg, _Label } from "../utils/Labels";

const EVENTGROUPCHANGE = "groupchange";
export const CHAT_GROUP_ID_PARAM = "groupid";
export type GroupChangeEvent = CustomEvent<{
    NewGroup: IGroup;
}>

export async function _ManageGroupContext(): Promise<boolean> {
    const { Parmas } = _GetHashInfo();
    const urlGroupId = Parmas?.get(CHAT_GROUP_ID_PARAM) ? Number(Parmas.get(CHAT_GROUP_ID_PARAM)) : null;
    const currentGroupId = _APP_DATA.userData.IdGrupo;
    console.log({ currentGroupId })
    let targetId = currentGroupId;

    if (!currentGroupId && !urlGroupId) return false;

    const urlGroupChange = urlGroupId && urlGroupId !== currentGroupId;

    if (!urlGroupChange) {
        console.log("No se detectó cambio de grupo");
        console.warn("-d", "GroupContext Validation in background");
        LoadAndValidateGroups(targetId, false, true);
        return true;
    }

    console.log("Se detectó cambio de grupo");
    targetId = urlGroupId;
    LOADING.Show();
    const succesGroupValidation = await LoadAndValidateGroups(targetId);
    LOADING.Dismiss();
    return succesGroupValidation;
}

async function LoadAndValidateGroups(targetGroupId: number, selectGroup = true, isInBackground = false): Promise<boolean> {
    let userGroups = await groupContext.getUserGroups() || [];
    if (isInBackground && !userGroups?.length) {
        userGroups = Array.from(_GRUPOSINFO_MAP.values()).map<IGroup>(g => (<IGroup>{ IdGrupo: g.IdGrupo }));
    }
    const targetGroup = userGroups.find(g => g.IdGrupo == targetGroupId);
    if (!targetGroup) {
        console.warn(`Grupo ${targetGroupId} no encontrado en los grupos del usuario`);
        isInBackground && _HashAssign("groups");
        return false;
    }
    if (!selectGroup) return true;

    const groupChangeSuccess = await groupContext.selectGroup(targetGroup);
    console.log("Cambio de grupo exitoso?", groupChangeSuccess);

    if (!groupChangeSuccess) {
        return false;
    }

    document.dispatchEvent(<GroupChangeEvent>new CustomEvent(EVENTGROUPCHANGE, {
        detail: { NewGroup: targetGroup }
    }));
    return true;
}

export const groupContext = {
    getUserGroups: async (): Promise<IGroup[]> => {
        return new Promise<IGroup[]>((resolve) => {
            _SvUsuarioObtenerGrupos((groups) => {
                resolve(groups);
            })
        })
    },
    selectGroup: async (group: IGroup): Promise<boolean> => {
        await _RestartAndCreateDB();
        console.warn("_RestartAndCreateDB");
        _SetGroupInUserInfo({
            IdGrupo: 0,
            IdEscuela: (_APP_DATA.userData?.IdKinder || 0),
            HoraInicio: "",
            HoraFin: "",
            IdNivel: 0,
            NombreGrupo: "",
            NombreNivel: "",
            EsPrincipal: false,
            NMessages: 0
        });

        let levelCfg = await groupContext.getEscolaridadCfg(group.IdNivel);
        console.warn("getEscolaridadCfg");
        if (!levelCfg || !levelCfg.length) {
            console.warn("no level cfg");
            return false;
        }

        const schoolChange = group.IdEscuela != _APP_DATA.userData.IdKinder;

        console.warn("Assign user group info");
        _SetGroupInUserInfo(group);
        _SvAlumnoClearChildsData();
        _ClearEventsData();
        _SvGrupoClearMaestrosInfoData();

        if (schoolChange) {
            _SvEscuelaClearKinderData();
            _SvLogroClearData();
        }
        return true;
    },
    getEscolaridadCfg: (idNivel: number, resetMaxDate = true, showToast = true): Promise<IConfiguration[] | null> => {
        return new Promise<IConfiguration[] | null>((resolve) => {
            _SvEscolaridadObtenerConfiguracion(idNivel, (status, result) => {
                if (status < 1 || !result) {
                    showToast && ShowToast(_Label("general.config"), _HttpMsg("escolaridad/ObtenerConfiguracion", status < 1 ? status : -60));
                    resolve(null);
                    return;
                }
                resolve(result);
            }, resetMaxDate);
        })
    },
    addOnGroupChangeEventListener: (callback: ((e: GroupChangeEvent) => void)) => {
        document.addEventListener(EVENTGROUPCHANGE, callback);
    },
    removeOnGroupChangeEventListener: (callback: ((e: GroupChangeEvent) => void)) => {
        document.removeEventListener(EVENTGROUPCHANGE, callback);
    }
}

declare global {
    interface DocumentEventMap {
        "groupchange": GroupChangeEvent;
    }
}